export enum WebhookEventStatus {
  SENT = 'sent',
  FAILED = 'failed',
  PENDING = 'pending'
}
